import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How I justified a weekend of videogaming and gorging as an exercise in hardcore personal improvement",
  "description": "",
  "published": "2010-04-06T00:00:00.000Z",
  "redirect_from": ["/blog/how-i-justified-a-weekend-of-videogaming-and-gorging-as-an-exercise-in-hardcore-personal-improvement/swizec/1282"],
  "categories": "Games, intrigues, life, Richard Burns Rally, Uncategorized, Yungas Road",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Bolivia_Yunga_Road.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/04/300px-Bolivia_Yunga_Road.jpg",
              "alt": "Yungas Road in Bolivia",
              "title": "Yungas Road in Bolivia"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Bolivia_Yunga_Road.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`And thus the three day easter weekend is behind us.`}</p>
    <p>{`Finally.`}</p>
    <p>{`Was getting a bit long to be honest.`}</p>
    <p>{`But what's more important than this is what I spent most of my weekend doing --> Videogames and piles upon piles of omnom yummy foods. Mostly `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Junk_food",
        "title": "Junk food"
      }}>{`junk foods`}</a>{` like bits of smoked pigs and copious amounts of chocolate ... very little eggs though, that's a bit silly considering easter is supposed to be all about eggs.`}</p>
    <p>{`No matter, food was omnom.`}</p>
    <p>{`Now, how can a guy justify wasting so many hours on something as simple as `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Video_game",
        "title": "Video game"
      }}>{`videogames`}</a>{`? Well, I could say I was trying to have fun ... but that's a cop out, way too easy.`}</p>
    <p>{`The most importantest thing is the mechanics of my adventures. The game I was playing was `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Richard_Burns_Rally",
        "title": "Richard Burns Rally"
      }}>{`Richard Burns Rally`}</a>{`, known far and wide as being one of the most, if not `}<em parentName="p">{`the`}</em>{` most, difficult and realistic rally simulation games. The map I was playing was Mineshaft from Australia, in my humble opinion the hardest fucking map in the whole game.`}</p>
    <p>{`See in most of the maps you drive in some forrest or something and the worst that can happen is you ram a tree or lose time by going a bit wide and over some grass or something.`}</p>
    <p>{`But Mineshaft is different. Most of that damn thing is comprised of a road with a sheer drop cliff on one side and a cliff on the other. It's a bit like trying to rally over the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Yungas_Road",
        "title": "Yungas Road"
      }}>{`Yungas Road`}</a>{` (most dangerous road in the world FYI).`}</p>
    <p>{`So what the fuck are you rambling about Swizec. Just get on with the fucking point already sheesh!`}</p>
    <p>{`Alright alright. :D`}</p>
    <p>{`My point is that ALL I did. For SEVERAL fucking hours. Was. Play. Richard Burns Rally. On. The. Hardest. Map.`}</p>
    <p>{`But why on god's fucking earth would you do something like that?`}</p>
    <p>{`Well, because I could.`}</p>
    <p>{`But the important bit is why I wanted to. The game is insane to play on keyboards and needless to say I never once survived to the end of the map. Out of ~200 plays. I never once finished.`}</p>
    <p>{`Wtf, masochist?`}</p>
    <p>{`No. Through endless repetition and stupid iteration I learned. I learned a whole fucking lot! By the time I got fed up with playing I was habitually achieving mid times several seconds faster than the world record for that stage. Yes, the realistic world record.`}</p>
    <p>{`*`}{`gasp`}{`*`}{` `}{`*`}{`shocker`}{`*`}</p>
    <p>{`But I still didn't finish, so the quest continues.`}</p>
    <p>{`My point is that this little experience teaches us a lot about life, the universe and everything. `}<strong parentName="p">{`Life is a series of insurmountable obstacles on the road to imminent disaster`}</strong></p>
    <p>{`And that is all. Remember that. Whenever you are failing in life, you're not failing, you're `}<em parentName="p">{`learning`}</em>{`. That's what it's all about. The more you fail the better a person you become, those times you dont' fail you haven't learned a single thing. So stop that.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/ef748e69-9a88-46da-a6e5-f4d35edc270b/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=ef748e69-9a88-46da-a6e5-f4d35edc270b",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      